var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.2333336mm",
    height: "4.2333336mm",
    viewBox: "0 0 4.2333336 4.2333336",
    id: "svg967",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g23220",
    transform: "translate(-0.12438843,0.37954715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3247",
    style: {
      fill: "#505050",
      strokeWidth: 1.11706,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    d: "M 0.70134777,2.576951 H 3.7807629 V 3.0747627 H 0.70134777 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect3247-3",
    style: {
      fill: "#505050",
      strokeWidth: 1.11706,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    transform: "rotate(-45)",
    d: "M -1.5022547,2.2452056 H 1.5771604 V 2.7430173 H -1.5022547 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7097",
    style: {
      fill: "#505050",
      strokeWidth: 1.11706,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    d: "M 0.95025361,2.8258569 A 0.24890584,0.24890584 0 0 1 0.70134777,3.0747628 0.24890584,0.24890584 0 0 1 0.45244193,2.8258569 0.24890584,0.24890584 0 0 1 0.70134777,2.5769511 0.24890584,0.24890584 0 0 1 0.95025361,2.8258569 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7097-5",
    style: {
      fill: "#505050",
      strokeWidth: 1.11706,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    d: "M 3.1277298,0.64838237 A 0.24890584,0.24890584 0 0 1 2.878824,0.8972882 0.24890584,0.24890584 0 0 1 2.6299182,0.64838237 0.24890584,0.24890584 0 0 1 2.878824,0.39947653 0.24890584,0.24890584 0 0 1 3.1277298,0.64838237 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7097-5-6",
    style: {
      fill: "#505050",
      strokeWidth: 1.11706,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    d: "M 4.0296685,2.8258569 A 0.24890584,0.24890584 0 0 1 3.7807627,3.0747628 0.24890584,0.24890584 0 0 1 3.5318568,2.8258569 0.24890584,0.24890584 0 0 1 3.7807627,2.5769511 0.24890584,0.24890584 0 0 1 4.0296685,2.8258569 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7097-6",
    style: {
      fill: "#505050",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 8.64555,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke"
    },
    d: "M 2.0206488,1.4219955 1.735275,1.725696 A 1.5092943,1.5092943 0 0 1 2.2104616,2.811338 L 2.6276135,2.807408 A 1.9264272,1.9264272 0 0 0 2.0206488,1.4219955 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuler);
export default __webpack_public_path__ + "static/media/euler.04feefb4.svg";
export { ForwardRef as ReactComponent };